import { VideoEmbedTokenResponse, VideoEmbedTokenSource } from "@videos/models/embedToken";
import { AppThunkAPI } from "@shared/models/redux";

type CallVideoEmbedTokenAPI = (
  videoId: string,
  source?: VideoEmbedTokenSource
) => AppThunkAPI<Promise<VideoEmbedTokenResponse>>;

export const callVideoEmbedTokenAPI: CallVideoEmbedTokenAPI =
  (videoId, source) => async (_dispatch, _getState, extra) => {
    const response = await extra<VideoEmbedTokenResponse>(
      `/documents/v1/Videos/${encodeURIComponent(videoId)}/embed-token`,
      {
        queryParams: source ? { source } : {},
      },
      // RequestService appends entitledUserId from the impersonation slice when active.
      // Fund-scoped videos need the impersonated user's entitlements; homepage ignores it.
      { includeUserId: source !== "homepage" }
    );

    return response.data;
  };
